<template>
    <v-dialog max-width="800" :value="value" @input="$emit('input', $event)">
        <v-card class="neu-glow pb-1">
            <v-card-title class="text-h5 mb-3"
            >
            Istruzioni Pasti
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click.native="$emit('input', false)">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
                <v-col md="6" cols="12">
                    <p>
                        Ai fini di semplificare la gestione dell'attività è possibile suddividere l'attività sia in funzione dello spazio che del tempo per adattarla alle proprie necessità:
                    </p>
                    <p>
                        A livello temporale la suddivisione standard è <strong>Pranzo/Cena</strong>, ma se ne possono aggiungere altre, ad esempio <strong>after-hours</strong>: Tutte quelle indicate (ed attive) vengono mostrate al cliente per la scelta<br />
                        Il gestore, nella tabella sotto, può suddividere i Pasti in Turni per una migliore gestione a livello grafico.
                    </p>  
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                        Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati. Cliccarlo per rendere definitive le modifiche
                    </p>
                </v-col>
                <v-col cols="12">
                    <p class="error--text">
                        <strong>Nota</strong> Limitazioni e Vincoli valgono solo per le prenotazioni fatte dai clienti.<br /> L'operatore può accettare prenotazioni in qualsiasi data.
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template> 
<script>
    export default
    {
        props:['value'],
        data () {
            return {
                dialog:false,
            }
        },
    }
</script>